module.exports = __webpack_public_path__ + "static/img/produto_p.68a022d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/guarana/produto_p.png
// module id = trf7
// module chunks = 0